import { getCoordinatorApi } from "@/lib/api";

export const revokeApiKey = async ({
  projectId,
  keyId,
  organizationId,
}: {
  projectId: string;
  keyId: string;
  organizationId: string;
}) => {
  const api = getCoordinatorApi({ organizationId, projectId });
  const { data } = await api.delete(`/api_keys/${keyId}`);
  return data;
};
